/* globals zc _ */

(function () {
  'use strict'

  zc.views.AlreadyJoinedView = zc.views.PageView.extend({
    template: _.template($('.already-joined-template').html())
  })
})()
